import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

import CONSTANTS from '../../_constants/constants';

import { SharedModule } from '../../_shared/shared.module';
import { AbilityService } from '../../_shared/services/ability.service';
import { DataService } from '../../_shared/services/data.service';
import { UtilService } from '../../_shared/services/util.service';
import { AlertService } from '../../_shared/services/alert.service';

import { DateFormatPipe } from '../../_shared/pipes/date-format.pipe';

import { Season } from '../shared/season.model';
import { SeasonService } from '../shared/season.service';

@Component({
  selector: 'app-season-list',
  templateUrl: './season-list.component.html',
  standalone: true,
  imports: [SharedModule, DateFormatPipe],
})
export class SeasonListComponent {
  @Input() seasons: Season[];
  @Input() meta;
  @Input() loadingSeasons: boolean;
  @Input() defaultLanguage;

  @Output() private selectedSeason = new EventEmitter<{
    season: Season;
    mode: string;
  }>();

  permissions = {
    canShow: this.abilityService.can('show_season_accountadmin'),
    canUpdate: this.abilityService.can('update_season_accountadmin'),
    canDestroy: this.abilityService.can('destroy_season_accountadmin'),
  };

  filterCriteria = this.seasonService.getFilterCriteria();

  dateDisplay = CONSTANTS.DATE_DISPLAY;
  today = CONSTANTS.TODAY_DATE;

  seasonOptions = [
    { value: 'current', label: 'CURRENT_SEASONS' },
    { value: 'all', label: 'ALL_SEASONS' },
  ];

  form: FormGroup;

  constructor(
    private seasonService: SeasonService,
    private abilityService: AbilityService,
    private dataService: DataService,
    public utilService: UtilService,
    private alertService: AlertService,
    private formBuilder: FormBuilder
  ) {
    this.form = this.formBuilder.group({
      by_current_seasons: '',
    });

    this.setDefaultFilters();
  }

  reloadSeasons() {
    this.filterCriteria = this.seasonService.getFilterCriteria();

    this.setDefaultFilters();

    this.getSeasons();
  }

  // Referenced from app-search-text-input
  onSearched({ field, value }) {
    this.filterSeasons(field, value);
  }

  filterSeasons(field, value) {
    this.filterCriteria = this.utilService.setFilterCriteria(this.filterCriteria, field, value);

    this.getSeasons();
  }

  clearSearchForm() {
    this.reloadSeasons();
  }

  // Referenced from app-sort-by
  onSorted({ sortBy, sortDir }) {
    this.filterCriteria.page = 1;
    this.filterCriteria.sortDir = sortDir;
    this.filterCriteria.sortedBy = sortBy;

    this.getSeasons();
  }

  // Referenced from app-table-footer
  onSelectedPage({ page, offset }) {
    this.filterCriteria.page = page;
    this.filterCriteria.offset = offset;

    this.getSeasons();
  }

  selectSeason(season: Season, mode = '') {
    if (!this.permissions.canShow) return;

    this.selectedSeason.emit({ season, mode });
  }

  changeSeasonStatus(season: Season) {
    this.seasonService.changeSeasonStatus(season).subscribe({
      next: () => {
        let successCallback = () => {
          this.utilService.changeItemRowStyle(season.id);
        };

        const params = {
          title: 'SURE_TO_DEACTIVATE_SEASON',
          message: 'DEACTIVATING_SEASON_WARNING',
          successMsg: 'SEASON_MODIFIED',
        };

        this.dataService.changeItemStatus('seasons', season, successCallback, params);
      },
      error: (response) => {
        this.alertService.open(response.data.error, 'error');
      },
    });
  }

  deleteSeason(season: Season) {
    this.seasonService.deleteSeason(season).subscribe({
      next: () => {
        let successCallback = () => {
          this.getSeasons();
        };

        const params = {
          title: 'DELETE_SEASON',
          // message: 'SURE_TO_DELETE_SEASON',
          reason: 'DELETE_ITEM_REASON',
          requireConfirmation: true,
          successMsg: 'DELETED_SEASON',
        };

        this.dataService.deleteItem('seasons', season, successCallback, params);
      },
      error: (response) => {
        this.alertService.open(response.data.error, 'error');
      },
    });
  }

  copySeason(seasonId) {
    this.seasonService.copySeason(seasonId).subscribe(() => {
      this.alertService.open('NEW_ADDED_SEASON');

      this.getSeasons();
    });
  }

  private getSeasons() {
    this.filterCriteria.lang = this.defaultLanguage.lang;

    this.loadingSeasons = true;
    this.seasonService.getSeasons(this.filterCriteria).subscribe((response) => {
      this.seasons = response.data;
      this.meta = response.meta;

      this.loadingSeasons = false;
    });
  }

  private setDefaultFilters() {
    // this.filterCriteria.by_name = '';
    // delete this.filterCriteria.by_name;

    this.filterCriteria.by_current_seasons = 'current';

    this.form.controls['by_current_seasons'].setValue(this.seasonOptions[0].value);
  }
}

// let successCallback = () => {
//   this.utilService.changeItemRowStyle(season.id);
// };

// this.dataService.changeItemStatus('seasons', season, successCallback, {});
